function hasValue(value) {
  return value !== null && value !== undefined;
}

function getFirstPositiveNumber(...values) {
  for (const value of values) {
    const parsedValue = Number(value);
    if (Number.isFinite(parsedValue) && parsedValue > 0) return parsedValue;
  }

  return undefined;
}

function getIsAnnualQuotation({ premiumSummary, policyModality, annualTotalValue }) {
  if (typeof premiumSummary?.isAnnual === 'boolean') return premiumSummary.isAnnual;
  if (policyModality !== 'annual') return false;

  return Number(annualTotalValue) > 0;
}

function getDisplayedTotal({ premiumSummary, quotationResponse, isAnnualQuotation }) {
  if (hasValue(premiumSummary?.total)) return premiumSummary.total;
  if (isAnnualQuotation) return quotationResponse?.annualTotalValue;
  if (hasValue(quotationResponse?.final_value_with_discount)) return quotationResponse.final_value_with_discount;

  return quotationResponse?.total ?? 0;
}

function hasValidAnnualInstallmentInfo({ isAnnualQuotation, annualInstallments, installmentValue }) {
  if (!isAnnualQuotation) return false;
  if (!(Number(annualInstallments) > 0)) return false;

  return Number(installmentValue) > 0;
}

function getAnnualInstallmentOption({ hasAnnualInstallmentInfo, annualInstallments, installmentValue, displayedTotal }) {
  if (!hasAnnualInstallmentInfo) return undefined;

  return {
    installments: annualInstallments,
    annualTotalValue: displayedTotal,
    installmentValue,
  };
}

export function getProposalPremiumDetails({ quotationData, quotationResponse }) {
  const premiumSummary = quotationResponse?.premiumSummary;
  const isAnnualQuotation = getIsAnnualQuotation({
    premiumSummary,
    policyModality: quotationData?.policy_modality,
    annualTotalValue: quotationResponse?.annualTotalValue,
  });
  const annualInstallments = getFirstPositiveNumber(
    premiumSummary?.installments,
    quotationResponse?.installments,
    quotationData?.installments,
  );
  const installmentValue = getFirstPositiveNumber(premiumSummary?.installmentValue, quotationResponse?.installmentValue);
  const hasAnnualInstallmentInfo = hasValidAnnualInstallmentInfo({
    isAnnualQuotation,
    annualInstallments,
    installmentValue,
  });
  const displayedTotal = getDisplayedTotal({ premiumSummary, quotationResponse, isAnnualQuotation });
  const displayedIof = premiumSummary?.iof ?? quotationResponse?.iof ?? 0;
  const selectedAnnualInstallmentOption = getAnnualInstallmentOption({
    hasAnnualInstallmentInfo,
    annualInstallments,
    installmentValue,
    displayedTotal,
  });

  return {
    isAnnualQuotation,
    annualInstallments,
    installmentValue,
    hasAnnualInstallmentInfo,
    displayedTotal,
    displayedIof,
    selectedAnnualInstallmentOption,
  };
}
